import React, { useState } from 'react';
import { FadeIn, Section } from './Section';
import { ArrowRightIcon, ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const profiles = [{
  title: 'Mujeres con una habilidad sin monetizar',
  desc: 'Sabés hacer algo valioso — diseño, cocina, idiomas, coaching, escritura, estética, lo que sea — pero no tenés un método para convertirlo en ingresos reales.'
}, {
  title: 'Empleadas que quieren independencia económica',
  desc: 'Tenés un sueldo que no alcanza o que depende de otros. Querés generar dinero propio, en tus términos.'
}, {
  title: 'Freelancers que cobran menos de lo que valen',
  desc: 'Ya tenés clientas pero seguís negociando tu precio a la baja. Necesitás reposicionarte y cobrar con confianza.'
}, {
  title: 'Mujeres que quieren transmitir su conocimiento',
  desc: 'Querés enseñar lo que sabés, crear servicios o productos digitales y construir una fuente de ingresos escalable.',
  badge: 'NUEVO'
}, {
  title: 'Mujeres listas para cambiar su relación con el dinero',
  desc: 'Sabés que hay creencias que te frenan y estás lista para trabajarlas de una vez.'
}];
function ProfileItem({
  profile,
  i
}: {
  profile: (typeof profiles)[0];
  i: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <FadeIn delay={i * 0.1} data-id="element-99">
      <div className="bg-cream p-5 md:p-10 border border-plum/5 hover:border-plum/10 transition-colors" data-id="element-100">
        {/* Mobile Toggle */}
        <button className="md:hidden flex justify-between w-full text-left items-center gap-4" onClick={() => setIsOpen(!isOpen)} data-id="element-101">
          <div className="flex items-center gap-3" data-id="element-102">
            <h3 className="font-serif text-lg text-plum" data-id="element-103">{profile.title}</h3>
            {profile.badge && <span className="bg-gold text-white text-[9px] font-bold tracking-widest uppercase px-1.5 py-0.5 rounded-sm flex-shrink-0" data-id="element-104">
                {profile.badge}
              </span>}
          </div>
          <ChevronDownIcon size={18} className={`text-plum/50 flex-shrink-0 transform transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-105" />
        </button>

        {/* Mobile Content */}
        <AnimatePresence data-id="element-106">
          {isOpen && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} className="md:hidden overflow-hidden" data-id="element-107">
              <p className="text-plum/70 leading-relaxed text-sm pt-3" data-id="element-108">
                {profile.desc}
              </p>
            </motion.div>}
        </AnimatePresence>

        {/* Desktop Content */}
        <div className="hidden md:block" data-id="element-109">
          <div className="flex items-center gap-3 mb-4" data-id="element-110">
            <h3 className="font-serif text-2xl text-plum" data-id="element-111">{profile.title}</h3>
            {profile.badge && <span className="bg-gold text-white text-[10px] font-bold tracking-widest uppercase px-2 py-1 rounded-sm" data-id="element-112">
                {profile.badge}
              </span>}
          </div>
          <p className="text-plum/70 leading-relaxed text-lg" data-id="element-113">{profile.desc}</p>
        </div>
      </div>
    </FadeIn>;
}
export function ForWho() {
  return <Section bg="cream-dark" data-id="element-114">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-20 items-start" data-id="element-115">
        <div className="lg:col-span-4 lg:sticky lg:top-32" data-id="element-116">
          <FadeIn data-id="element-117">
            <h2 className="text-xs md:text-sm font-bold tracking-[0.2em] uppercase text-plum/60 mb-4" data-id="element-118">
              ¿Para quién es Mujer Expansiva?
            </h2>
            <p className="font-serif md:text-5xl text-plum mb-6 md:mb-8 text-[26px]" data-id="element-119">
              Diseñado para vos si querés dejar de subvalorarte y empezar a
              vivir de lo que sabés.
            </p>
            <a href="#pricing" className="inline-flex items-center gap-2 text-xs md:text-sm font-bold tracking-widest uppercase text-gold hover:text-plum transition-colors" data-id="element-120">
              ¿No estás segura si es para vos? <br data-id="element-121" /> Tenés 7 días de garantía{' '}
              <ArrowRightIcon size={16} data-id="element-122" />
            </a>
          </FadeIn>
        </div>

        <div className="lg:col-span-8 flex flex-col gap-3 md:gap-6" data-id="element-123">
          {profiles.map((profile, i) => <ProfileItem key={i} profile={profile} i={i} data-id="element-124" />)}
        </div>
      </div>
    </Section>;
}